import { BodyDefault, BodyStrong } from '@terra/ui-design-system';
import { splitHighlightSegments } from './launcher-targets';

type HighlightedTargetNameProps = {
  name: string;
  query: string;
};

export function HighlightedTargetName({
  name,
  query,
}: HighlightedTargetNameProps) {
  const segments = splitHighlightSegments({ text: name, query });

  return (
    <BodyDefault truncate flex="1" minW="0" data-bi-unmask="true">
      {segments.map((segment, index) =>
        segment.isMatch ? (
          <BodyStrong key={index} as="span">
            {segment.text}
          </BodyStrong>
        ) : (
          <span key={index}>{segment.text}</span>
        ),
      )}
    </BodyDefault>
  );
}
